import React from 'react'
import { UploadModal } from './customerModal'
import { useSelector } from 'react-redux'
const CustomerFile = ({...props}) => {

  const { customerFile , failedCustomers} = useSelector(
    (state) => state.alertAndNotifications
  );
  

  return (
  <>
    <UploadModal
   {...props}
    customerFileData={customerFile}
    failedCustomers={failedCustomers}
    />
  </>
  )
}

export default CustomerFile